import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getPaginaOkTemplateById,
  updatePaginaOkTemplate,
  getSeccionTemplateById,
  updateSeccionTemplate,
  getMensajeWhatsapp,
} from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_PAGINA_OK_TEMPLATE_BY_ID(action) {
  try {
    const paginaOkTemplate = yield call(getPaginaOkTemplateById, action.payload)
    if (paginaOkTemplate.ok) {
      yield put({
        type: actions.PAGINA_OK_TEMPLATE_BY_ID_LOAD_SUCCEEDED,
        payload: paginaOkTemplate.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar página ok template')
      put({
        type: actions.PAGINA_OK_TEMPLATE_BY_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PAGINA_OK_TEMPLATE_BY_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_PAGINA_OK_TEMPLATE(action) {
  try {
    const paginaOkTemplate = yield call(updatePaginaOkTemplate, action.payload)
    if (paginaOkTemplate.ok) {
      putMessage(messageType.SUCCESS, 'Página Ok Template modificada correctamente')
      yield put({
        type: actions.PAGINA_OK_TEMPLATE_UPDATE_SUCCEEDED,
        payload: paginaOkTemplate.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Página Ok Template')
      yield put({
        type: actions.PAGINA_OK_TEMPLATE_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Página Ok Template')
    yield all([
      put({
        type: actions.PAGINA_OK_TEMPLATE_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_SECCION_TEMPLATE_BY_ID(action) {
  try {
    const seccionTemplate = yield call(getSeccionTemplateById, action.payload)
    if (seccionTemplate.ok) {
      yield put({
        type: actions.SECCION_TEMPLATE_BY_ID_LOAD_SUCCEEDED,
        payload: seccionTemplate.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar sección template')
      put({
        type: actions.SECCION_TEMPLATE_BY_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.SECCION_TEMPLATE_BY_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_SECCION_PAGINA_OK_TEMPLATE(action) {
  try {
    const seccionTemplate = yield call(updateSeccionTemplate, action.payload)
    if (seccionTemplate.ok) {
      putMessage(messageType.SUCCESS, 'Sección Template modificada correctamente')
      yield put({
        type: actions.SECCION_TEMPLATE_UPDATE_SUCCEEDED,
        payload: seccionTemplate.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Sección Template')
      yield put({
        type: actions.SECCION_TEMPLATE_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Sección Template')
    yield all([
      put({
        type: actions.SECCION_TEMPLATE_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_MENSAJES_WHATSAPP(action) {
  try {
    const result = yield call(getMensajeWhatsapp, action.payload)
    if (result.ok) {
      yield put({
        type: actions.SECCION_MENSAJE_WHATSAPP_SUCCEEDED,
        payload: result.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los mensajes de WhatsApp')
      put({
        type: actions.SECCION_MENSAJE_WHATSAPP_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.SECCION_MENSAJE_WHATSAPP_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.PAGINA_OK_TEMPLATE_BY_ID_LOAD_REQUESTED, GET_PAGINA_OK_TEMPLATE_BY_ID),
    takeEvery(actions.PAGINA_OK_TEMPLATE_UPDATE_REQUESTED, UPDATE_PAGINA_OK_TEMPLATE),
    takeEvery(actions.SECCION_TEMPLATE_BY_ID_LOAD_REQUESTED, GET_SECCION_TEMPLATE_BY_ID),
    takeEvery(actions.SECCION_TEMPLATE_UPDATE_REQUESTED, UPDATE_SECCION_PAGINA_OK_TEMPLATE),
    takeEvery(actions.SECCION_MENSAJE_WHATSAPP_REQUESTED, GET_MENSAJES_WHATSAPP),
  ])
}
